/*
 * The staff app is the same build under /staff, installable on its own: it
 * has its own manifest (name "Kathkuni", start_url /staff) and a canvas-coloured
 * bar. Swapped in before first paint, before the router moves /staff behind the hash.
 */
const path = window.location.pathname;
const hash = window.location.hash;
if (path === "/staff" || path.startsWith("/staff/") || hash.startsWith("#/staff")) {
  document.querySelector('link[rel="manifest"]')?.setAttribute("href", "/staff.webmanifest");
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", "#FAF4E8");
  document.querySelector('meta[name="apple-mobile-web-app-title"]')?.setAttribute("content", "Kathkuni");
  document.title = "Kathkuni";
}

export {};
